import { atom } from "recoil";

export const dialogState = atom<{
  title: string;
  isCancel?: boolean;
  confirm: any;
} | null>({
  key: "dialog",
  default: null,
});
